var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.001a10 10 0 1110 10 10.011 10.011 0 01-10-10zm1.5 0a8.5 8.5 0 108.5-8.5 8.51 8.51 0 00-8.5 8.5zm11.638 3.633l-.091-.047-3.77-2.249a.751.751 0 01-.357-.532l-.008-.112V7.847a.75.75 0 011.493-.1l.006.1v4.42l3.4 2.032a.75.75 0 01.306.937l-.046.091a.75.75 0 01-.938.307z",
    fill: "currentcolor"
  })));
}

export default SvgAdminClock;